<template>
  <focus-page :title="title" :message="message">
    <wo-alert v-if="error" mod-error><span v-t="'oauth.error.credentials'" /></wo-alert>
    <form v-if="validAuthorization" novalidate :action="oauthAuthorization.url" method="POST">
      <wo-label for="email" v-t="'form.email.label'"></wo-label>
      <wo-input-field id="email" name="email" mod-block :placeholder="$t('form.email.placeholder')" v-model="credentials.email" autocomplete="email username" v-focus="true" />
      <wo-grid>
        <wo-column width="6">
          <wo-label for="password" v-t="'form.password.label'"></wo-label>
        </wo-column>
        <wo-column width="6" v-wo-align:right>
          <po-route-link :value="resetRoute" label-key="signin.forgotPassword" :new-window="true" tabindex="-1" />
        </wo-column>
      </wo-grid>
      <wo-input-field id="password" name="password" mod-block :placeholder="$t('form.password.placeholder')" type="password" autocomplete="current-password" v-model="credentials.password" />
      <wo-region v-wo-align:right>
        <wo-button tag-name="a" :href="oauthAuthorization.cancel_url" v-t="'general.action.cancel'" mod-secondary></wo-button>
        <wo-button class="btn btn-primary" type="submit" :disabled="!valid"><span v-t="'signin.action.confirm'"></span></wo-button>
      </wo-region>
    </form>
     <wo-typography v-else-if="oauthAuthorization">
        <wo-link :href="oauthAuthorization.cancel_url">{{ returnMessage }}</wo-link>
      </wo-typography>
    <account-focus-footer slot="footer" />
  </focus-page>
</template>

<script>

import { mapState } from 'vuex'
import { oauthAuthorizationRepository } from '@/repository/identity'
import { RESET_PASSWORD_REQUEST } from '@/routes/identity'

import FocusPage from '@/components/layout/FocusPage'
import AccountFocusFooter from '@/components/identity/AccountFocusFooter'

export default {
  components: { FocusPage, AccountFocusFooter },
  props: {
    authenticationId: { type: String },
    error: { type: Boolean },
    email: { type: String }
  },
  data () {
    return {
      loading: true,
      credentials: {
        email: undefined,
        password: undefined
      }
    }
  },
  computed: mapState({
    env: state => state.environment.current,
    oauthAuthorization: state => state.identity.oauthAuthorization,
    resetRoute: () => RESET_PASSWORD_REQUEST,
    validAuthorization () {
      return this.oauthAuthorization && !this.oauthAuthorization.authenticated
    },
    valid () {
      return this.credentials.email && this.credentials.password
    },
    title () {
      return this.$t('signin.title', this.messageParams)
    },
    message () {
      if (!this.loading) {
        return this.validAuthorization ? this.authMessage : this.$t('oauth.error.invalid')
      }
    },
    authMessage () {
      return this.$t('oauth.message', this.messageParams)
    },
    returnMessage () {
      return this.$t('oauth.return', this.messageParams)
    },
    messageParams () {
      return { clientName: this.oauthAuthorization && this.oauthAuthorization.client.name, appName: this.$t(this.env.appTitleKey) }
    }
  }),
  created () {
    this.credentials.email = this.email
    if (this.authenticationId) {
      this.$store.dispatch(oauthAuthorizationRepository.find, { id: this.authenticationId })
        .finally(this.loaded)
    } else {
      this.loaded()
    }
  },
  methods: {
    loaded () {
      this.loading = false
    }
  }
}
</script>
